import React from "react";
import { FileGeneratorUI } from "./components";

const NotesPerJob = () => {
  return <FileGeneratorUI scope="NOTES|ALL|V1" title="Generate Notes CSV File." entity="notes" />;
};

export { NotesPerJob };
